import { lazy } from 'react';

export default lazy(
  () =>
    import(
      /* webpackChunkName: "all-deals-and-discounts" */
      './AllDealsAndDiscounts'
    )
);
